// @file Integration permissions settings store
import { getVuexStore } from '@@/bits/pinia'
import { defineStore } from 'pinia'
import type { UserOptions } from 'types'
import { computed, ref } from 'vue'
import type { DashboardSettingsState } from 'vuexstore/dashboard_settings'

export const useSettingsIntegrationPermissionsStore = defineStore('settingsIntegrationPermissions', () => {
  // State
  const googleDriveEmail = ref<string | null>(null)
  const userOptions = computed((): UserOptions => getVuexStore<DashboardSettingsState>()?.getters.userOptions)

  // Getters

  // Actions
  function initialize(): void {
    googleDriveEmail.value = userOptions.value.linkedGoogleDriveEmail ?? null
  }

  function setGoogleDriveEmail(email: string): void {
    void getVuexStore<DashboardSettingsState>()?.dispatch('updateUserOptions', { linkedGoogleDriveEmail: email })
    googleDriveEmail.value = email
  }

  function clearGoogleDriveEmail(): void {
    void getVuexStore<DashboardSettingsState>()?.dispatch('updateUserOptions', { linkedGoogleDriveEmail: null })
    googleDriveEmail.value = null
  }

  return {
    // State
    googleDriveEmail,

    // Getters

    // Actions
    initialize,
    setGoogleDriveEmail,
    clearGoogleDriveEmail,
  }
})
